import styles from "./Counter.module.scss";

interface CounterProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

/** Quantity stepper, matching the ± idiom the Slider already uses. */
function Counter(props: CounterProps) {
  const { value, onChange, min = 1, max = 99 } = props;

  const atMin = value <= min;
  const atMax = value >= max;

  return (
    <div className={styles.counterContainer}>
      <i
        className={`las la-minus-circle icon-xl ${styles.counterIcon} ${
          atMin ? styles.counterIconDisabled : ""
        }`}
        role="button"
        aria-label="decrease"
        onClick={() => !atMin && onChange(value - 1)}
      />
      <p className={`body-bold-medium ${styles.counterValue}`}>{value}</p>
      <i
        className={`las la-plus-circle icon-xl ${styles.counterIcon} ${
          atMax ? styles.counterIconDisabled : ""
        }`}
        role="button"
        aria-label="increase"
        onClick={() => !atMax && onChange(value + 1)}
      />
    </div>
  );
}

export default Counter;
